<template>
  <div class="wrapper">
    <div class="section page-header" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 text-center">
            <h1 class="title-white">{{ $t("yoyolumi.header_title") }}</h1>
          </div>
        </div>
        <div v-if="isMobileDevice" class="md-layout margin-top-64">
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">{{ $t("common.time") }}<br />2022 - 2024</h4>
          </div>
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">
              {{ $t("common.role") }}<br />
              Product Lead, AIGC Vision & Strategy
            </h4>
          </div>
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">
              {{ $t("common.platform") }}<br />Mobile, Desktop
            </h4>
          </div>
        </div>
        <div v-else class="md-layout margin-top-64">
          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">{{ $t("common.time") }}<br />2022 - 2024</h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">
                {{ $t("common.role") }}<br />Product Lead, AIGC Vision &
                Strategy
              </h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">
                {{ $t("common.platform") }}<br />Mobile, Desktop
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-black">
      <div class="large-section large-section-black">
        <div class="section">
          <div class="container">
            <div class="md-layout" :style="introStyle">
              <div
                class="md-layout-item md-size-100 md-xsmall-size-100 text-center"
              >
                <h2 class="title-white intro_text_margin">
                  {{ $t("yoyolumi.intro") }}
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100">
                <h2 class="title-white text-left">
                  {{ $t("yoyolumi.project.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-60 md-small-size-100">
                <h4 class="content-white text-left">
                  {{ $t("yoyolumi.project.description1") }}
                </h4>
                <h4 class="content-white text-left">
                  {{ $t("yoyolumi.project.description2") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <img :src="intro_phones[0].image" />
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <img :src="intro_phones[1].image" />
              </div>
              <div
                class="md-layout-item md-size-50 md-small-size-100 margin-top-32"
              >
                <img :src="intro_phones[2].image" />
              </div>
              <div
                class="md-layout-item md-size-50 md-small-size-100 margin-top-32"
              >
                <img :src="intro_phones[3].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section text-center">
          <div class="container">
            <div class="team">
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-33 md-small-size-100">
                  <md-card class="md-card-plain transparent">
                    <h1 class="card-title-white decoration">
                      {{ $t("yoyolumi.card1.number") }}
                      <h3 class="card-description-white">
                        {{ $t("yoyolumi.card1.description1") }}
                      </h3>
                    </h1>
                    <md-card-content>
                      <p class="card-description">
                        {{ $t("yoyolumi.card1.description2") }}
                      </p>
                    </md-card-content>
                  </md-card>
                </div>
                <div class="md-layout-item md-medium-size-33 md-small-size-100">
                  <md-card class="md-card-plain transparent">
                    <h1 class="card-title-white decoration">
                      {{ $t("yoyolumi.card2.number") }}
                      <h3 class="card-description-white">
                        {{ $t("yoyolumi.card2.description1") }}
                      </h3>
                    </h1>
                    <md-card-content>
                      <p class="card-description">
                        {{ $t("yoyolumi.card2.description2") }}
                      </p>
                    </md-card-content>
                  </md-card>
                </div>
                <div class="md-layout-item md-medium-size-33 md-small-size-100">
                  <md-card class="md-card-plain transparent">
                    <h1 class="card-title-white decoration">
                      {{ $t("yoyolumi.card3.number") }}
                      <h3 class="card-description-white">
                        {{ $t("yoyolumi.card3.description1") }}
                      </h3>
                    </h1>
                    <md-card-content>
                      <p class="card-description">
                        {{ $t("yoyolumi.card3.description2") }}
                      </p>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100">
                <h2 class="title-white text-left">
                  {{ $t("yoyolumi.liveseries.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-60 md-small-size-100 mx-auto">
                <h4 class="content-white text-left">
                  {{ $t("yoyolumi.liveseries.description1") }}<br />
                  {{ $t("yoyolumi.liveseries.description2") }}
                </h4>
              </div>
            </div>

            <div
              class="md-layout-item md-grid-5050 section-internal-padding-lumilive "
            >
              <div>
                <img :src="lumilive[0].image" />
              </div>
              <div>
                <img :src="lumilive[1].image" />
              </div>

              <h4
                class="content-white text-left margintopzero "
                @click="openWebsite('lumilive02')"
              >
                Lumilive 2.0 - Abstract Love (36min)
              </h4>
            </div>

            <div
              class="md-layout-item md-grid-5050 section-internal-padding-lumilive"
            >
              <div>
                <img :src="lumilive[2].image" />
              </div>
              <div>
                <img :src="lumilive[3].image" />
              </div>
              <h4
                class="content-white text-left margintopzero"
                @click="openWebsite('lumilive03')"
              >
                Lumilive 3.0 - Summertime (45min)
              </h4>
            </div>

            <div
              class="md-layout-item md-grid-5050 section-internal-padding-lumilive"
            >
              <div>
                <img :src="lumilive[4].image" />
              </div>
              <div>
                <img :src="lumilive[5].image" />
              </div>
              <h4
                class="content-white text-left margintopzero"
                @click="openWebsite('lumilive04')"
              >
                Lumilive 4.0 - Snowflakes For You (50min)
              </h4>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100">
                <h2 class="title-white text-left">
                  {{ $t("yoyolumi.companionship.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-60 md-small-size-100 mx-auto">
                <h4 class="content-white text-left">
                  {{ $t("yoyolumi.companionship.description1") }}<br />
                  {{ $t("yoyolumi.companionship.description2") }}
                </h4>
              </div>
            </div>
            <div
              class="md-layout-item md-size-100 md-small-size-100 mx-auto section-internal-padding"
            >
              <div>
                <img :src="companionship[0].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100">
                <h2 class="title-white text-left">
                  {{ $t("yoyolumi.world.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-60 md-small-size-100 mx-auto">
                <h4 class="content-white text-left">
                  {{ $t("yoyolumi.world.description1") }}<br />
                  {{ $t("yoyolumi.world.description2") }}
                </h4>
              </div>
            </div>
            <div
              class="md-layout-item md-size-100 md-small-size-100 mx-auto section-internal-padding"
            >
              <div>
                <img :src="world[0].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100">
                <h2 class="title-white text-left">
                  {{ $t("yoyolumi.future.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-60 md-small-size-100 mx-auto">
                <h4 class="content-white text-left">
                  {{ $t("yoyolumi.future.description1") }}<br />
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div
                class="md-layout-item small-padding md-size-40 md-small-size-50"
              >
                <img :src="experience_enhancements[0].image" />
              </div>
              <div
                class="md-layout-item small-padding md-size-40 md-small-size-50"
              >
                <img :src="experience_enhancements[1].image" />
              </div>
              <div
                class="md-layout-item small-padding md-size-20 md-small-size-50"
              >
                <img :src="experience_enhancements[2].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="video-wrapper">
              <img
                class="video-image-ratio"
                src="@/assets/img/common/video_placeholder.png"
              />
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/8Ob4SN4YnIc?si=Sp3xVQwT7ylqxBSw"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- main-->
  </div>
  <!-- wrapper-->
</template>

<script>
export default {
  bodyClass: "yoyolumi-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/yoyolumi/background.png")
    },
    intro_background: {
      type: String,
      default: require("@/assets/img/yoyolumi/yoyolumi_intro_background.png")
    }
  },
  data() {
    return {
      isMobileDevice: this.$isMobile,
      intro_phones: [
        { image: require("@/assets/img/yoyolumi/intro_phone1.png") },
        { image: require("@/assets/img/yoyolumi/intro_phone2.png") },
        { image: require("@/assets/img/yoyolumi/intro_phone3.png") },
        { image: require("@/assets/img/yoyolumi/intro_phone4.png") }
      ],
      portrait_phones: [
        { image: require("@/assets/img/yoyolumi/portrait_phone1.png") },
        { image: require("@/assets/img/yoyolumi/portrait_phone2.png") }
      ],
      experience_enhancements: [
        {
          image: require("@/assets/img/yoyolumi/experience_enhancement_1.png")
        },
        {
          image: require("@/assets/img/yoyolumi/experience_enhancement_2.png")
        },
        { image: require("@/assets/img/yoyolumi/experience_enhancement_3.png") }
      ],
      ideations: [
        { image: require("@/assets/img/yoyolumi/ideation_1.png") },
        { image: require("@/assets/img/yoyolumi/ideation_2.png") }
      ],
      companionship: [
        { image: require("@/assets/img/yoyolumi/companionship.png") }
      ],
      world: [{ image: require("@/assets/img/yoyolumi/world.png") }],
      lumilive: [
        { image: require("@/assets/img/yoyolumi/lumilive_1.png") },
        { image: require("@/assets/img/yoyolumi/lumilive_2.png") },
        { image: require("@/assets/img/yoyolumi/lumilive_3.png") },
        { image: require("@/assets/img/yoyolumi/lumilive_4.png") },
        { image: require("@/assets/img/yoyolumi/lumilive_5.png") },
        { image: require("@/assets/img/yoyolumi/lumilive_6.png") }
      ]
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 43.82%, rgba(0, 4, 52, 0.59) 69.86%, rgba(0, 1, 18, 0.855896) 85.66%, #000000 100%),  url(${this.header})`
      };
    },
    introStyle() {
      return {
        backgroundImage: `url(${this.intro_background})`,
        backgroundSize: `cover`
      };
    }
  },
  methods: {
    openWebsite(website) {
      if (website === "lumilive03") {
        window.open(
          "https://www.youtube.com/watch?v=nTr_s7e-aUc&t=7s",
          "_blank"
        );
      } else if (website === "lumilive02") {
        window.open(
          "https://www.youtube.com/watch?v=B3ZeCQmgJwo&t=1693s&ab_channel=Lumi_N0va",
          "_blank"
        );
      } else if (website === "lumilive04") {
        window.open(
          "https://www.youtube.com/watch?v=m0lztaRC8FQ&t=12s&ab_channel=Lumi_N0va",
          "_blank"
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.intro_text_margin {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem;
  margin-left: 2rem;
  margin-right: 2rem;
}
.press-cursor {
  cursor: pointer;
}
.press-title-padding-top {
  padding-top: 2.85rem;
}
.press-name-margin-top {
  margin-top: 0.25rem;
}
.press-portrait-phones {
  padding-bottom: 0;
}
.padding-to-align-bottom {
  padding-bottom: 22px;
}
a {
  color: none;
  text-decoration: none;
}
.transparent {
  background-color: transparent !important;
}

.item-nopadding {
  padding: 0px !important;
  display: grid;
}

.md-grid-5050 {
  // padding-top: 30px;
  grid-template-columns: 50fr 50fr;
}

@media (max-width: 991px) {
  .md-grid-5050 {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }
}

.section-internal-padding-lumilive {
  padding: 60px 0 0px 0;
}

.margintopzero {
  margin: 5px 0 -5px !important;
  text-decoration: underline;
}
</style>
